module.exports = __webpack_public_path__ + "static/product4-a-88e7837a7d4cd7df4482fd6f46e7e6e9.png";